<div #localVideoContainer >

</div>